import React from 'react';
import diagram from "../../images/diagram.png"
import diagram2 from "../../images/diagram2.png"
import image from "../../images/Article (4).png"
import image1 from "../../images/datawithSS.png"
import image2 from "../../images/Rectangle 333 (1).png"
import image3 from "../../images/article (3).png"
import image7 from "../../images/Article (9).png"

const SIDEBAR_ARTICLES = [
  {
    id: 'sidebar-1',
    type: 'Events',
    typeColor: 'text-[#7BC216]',
    tag: 'Clean Transport',
    title: 'Netzence set to unveil clean mobility hailing App in June 2026',
    excerpt: 'At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems',
    readTime: '5 mins read',
    date: '2/3/2026',
    imageUrl: image1,
    heightClass: 'h-[497px]'
  },
  {
    id: 'sidebar-2',
    type: 'NEWS',
    typeColor: 'text-[#0D5EBA]',
    tag: 'Clean Energy',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'Average citizen that I am, I’d heard about climate change and wanted some accurate information about it...',
    readTime: '8 mins read',
    date: '18/2/2026',
    imageUrl: image2,
    heightClass: 'h-[536px]'
  },
  {
    id: 'sidebar-3',
    type: 'ADVERT',
    typeColor: 'text-[#099137]',
    tag: 'Circular Economy',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape, the practice of',
    readTime: '4 mins read',
    date: '21/2/2026',
    imageUrl: image3,
    heightClass: 'h-[536px]'
  },
  {
    id: 'sidebar-4',
    type: 'ARTICLE',
    typeColor: 'text-[#7BC216]',
    tag: 'Clean Energy',
    title: 'Shared Responsibility for Climate Change: Who Should Fund the Solutions?',
    excerpt: 'The UK\'s first geothermal plant in Cornwall generates renewable power and extracts lithium for EVs.',
    readTime: '10 mins read',
    date: '28/2/2026',
    imageUrl: image7,
    heightClass: 'h-[530px]'
  }
];

export default function SustainableInvestingArticle() {
  return (
    <div className="w-full min-h-screen bg-white py-12 px-4 lg:px-[120px] font-['SF_Pro_Display']">
      
      {/* Main Layout Wrapper (Frame 2147228719) */}
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-start gap-[32px]">
        
        {/* Left Column (Main Content) */}
        <main className="w-full lg:w-[758px] flex flex-col gap-[32px]">
          <div className="w-full h-[350px] lg:h-[612px] rounded-[12px] bg-gray-100 overflow-hidden">
             <img src={image} alt="Banner" className="w-full h-full object-cover" />
          </div>

          <article className="w-full flex flex-col gap-[64px] text-[#3B3B3B]">
            <div className="flex flex-col gap-[16px] text-[#3B3B3B]">
              <p className="text-[18px] leading-[28px] text-justify">
                Most of the goods we consume come with some sort of packaging. While the goods are consumed, the packaging is essentially discarded. We drink beer but throw the bottles; we consume medicines but discard the phials. Most of this packaging ends up in landfills, incinerators, or just litter around.
              </p>
              <p className="text-[18px] leading-[28px] text-justify">
With increased consumerism and population growth, packaging waste has been increasing significantly. The average per capita waste created by packaging in the European Union is 186.5 kilograms per person per year. The US leads with 239 kilograms, while India is at 9 kilograms, but growing exponentially. Imagine the situation as India grows and its average per capita packaging waste inches closer to that of the US.
              </p>
              <p className="text-[18px] leading-[28px] text-justify">
                Besides consuming natural resources like trees, fossil fuels, and other minerals and metals, there is a significant amount of energy consumed in the production of packaging. All this culminates in resource depletion, greenhouse gases, and pollution – ground, water and air! These are factors responsible for the deteriorating environment, changing climate and falling human health.

              </p>
              <p className="text-[18px] leading-[28px] text-justify">
                Plastics which constitute 40% of the packing material are not bio-degradable and remain in the environment for centuries. Only 9% are recycled while most end up in oceans where they impact marine life. The balance ends up in landfills or is incinerated. In either case, they release greenhouse gases and other toxins. Unbridled plastic use is also creating microplastic waste which has now found its way to the human bloodstream. A recent survey done in the Netherlands found some 77% of human blood samples taken had microplastics in them. Microplastics are known to cause inflammation in the body, increase oxidative stress, and disrupt our endocrinal system.
                </p>
                <p className="text-[18px] leading-[28px] text-justify"  >
                    Another 30% of the packaging comes from paper and cardboard. While biodegradable, it is resource intensive leading to deforestation, and excessive use of water and energy. Similarly, metals, glass, wood, and other materials used in packaging have an environmental, climate and health impact.
                </p>
                <p className="text-[18px] leading-[28px] text-justify">
                    Can we do away with packaging completely? No.
Can we reduce the total amount of packaging? Yes.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    Packaging is essential and has many benefits including protecting the products from damage, increasing their shelf life and making them easily transportable. However, its life is ephemeral – ending as soon as we buy or consume a product. It follows a linear model – where we take material resources, use some energy to convert them into packaging, use it to house the product and then throw the packaging as soon as we use the product. This is wasteful.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    Packaging is essential and has many benefits including protecting the products from damage, increasing their shelf life and making them easily transportable. However, its life is ephemeral – ending as soon as we buy or consume a product. It follows a linear model – where we take material resources, use some energy to convert them into packaging, use it to house the product and then throw the packaging as soon as we use the product. This is wasteful.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    The first step in this process of creating a Common Design Reusable Packaging system would be to standardize packaging design for various product categories. This includes selecting materials that are strong, nonpolluting and easily recyclable and agreeing on physical aspects like shape, size, labeling spaces and other specifications that are acceptable to all parties. Such a design would enable the same packaging to be used by different manufacturers.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    An ecosystem for collecting used packages from the consumers, cleaning them, listing them on a digital exchange for buying and selling, and then shipping them to the manufacturers for reuse will need to be set up.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    The same packaging could do multiple rounds.
</p>
<p className="text-[18px] leading-[28px] text-justify">
    This is no slam-dunk and calls for massive Industry cooperation. Regulators may have to step in and enforce coopetition – where industry players cooperate and compete at the same time. It could be a tricky marketing issue for companies and therefore should first be tried only for categories where packaging is less of a differentiating factor and has a lower influence on consumer choice. Things like medicines, spirits and generic food items could be good initial candidates. The branding can still happen through changeable labels. Such a system would reduce the need for overall packaging and thus lower environmental pollution, greenhouse gases and the energy used for their manufacture.
</p>
<img src={diagram} >

</img>
<p className="text-[18px] leading-[28px] text-justify">
    One may ask, why do we need to standardize packaging design? Why cannot every manufacturer collect their own packages and reuse them? The logistics and expense involved in collecting packaging of a specific manufacturer and getting it back for re-circulation would not be a viable option – both financially and logistically. Hence adopting a common standardized packaging design in the industry for a similar pool of products becomes essential so that geographically dispersed, used packages can be economically collected and shipped to whichever manufacturer needs them, based on marketplace dynamics. The transactions could be facilitated by a digital exchange.
</p>
<img src={diagram2} >

</img>
<p className="text-[18px] leading-[28px] text-justify">
This needs a gargantuan effort and calls for a mix of industry coordination, policy promulgation, infrastructure development and systems set-up, backed by a consumer awareness drive.</p>
        <p className="text-[18px] leading-[28px] text-justify">
            The stakeholders in this initiative will be:
        </p>
        <p className="text-[18px] leading-[28px] text-justify"  >
            Corporations: We will need to carefully select industry groups for whom packaging is less of a basis of competition, for example pharma industry with its phials, the spirits industry with its wine and beer bottles, oil industry with its lubes. By adopting a common design, they will not only help solve the environmental issues but will also be able to increase their profitability by reducing packaging costs through reuse.
            </p>
            <p className="text-[18px] leading-[28px] text-justify text-black">
                Municipalities / Governments: We will need to advocate the promulgation of suitable laws and regulations for mass adoption of reusable packaging. They will stand to benefit, as their burden for waste disposal will reduce and cities will become cleaner.
                </p>
                <p className="text-[18px] leading-[28px] text-justify">
                    Consumers: We will need to suitably educate and incentivize the consumers to partake in the eco-system by returning used packaging for re-circulation.
                </p>
                <p className="text-[18px] leading-[28px] text-justify ">
                    I believe the timing to initiate this program is now. As we know, a change can be best accomplished during a period of disruption. We are currently seeing a major disruption in the retail industry as it shifts from a conventional brick-and-mortar model to an online and omni-channel format. This is changing the relationship between consumers and product packaging. In a brick-and-mortar retail environment, packaging serves the function of merchandising and protection while in an online environment, its function changes to ease of shipment and protection.
                </p>
                <p className="text-[18px] leading-[28px] text-justify text-black">
                    Add to that, consumer awareness and public concern about sustainability. Both are currently high and hence the timing could be opportune for introducing Common Design Reusable Packaging.
                </p>
                <p className="text-[18px] leading-[28px] text-justify text-black">
                    Image
                </p>
                <p className='text-[18px] leading-[28px] text-justify '>
                    A corollary benefit of this system besides environment, climate and health would be additional employment generation, as it opens up a new sector that needs people to collect, clean and handle the circulation of packages.
                </p>
                <p className='text-[18px] leading-[28px] text-justify text-black'>
                    Source:
                    </p>
                    <a href="https://www.sir.advancedleadership.harvard.edu/Common Design Reusable Packaging: Doing More with Less — Harvard ALI Social Impact Review" className="text-[18px] text-[#3B3B3B] underline break-all">
                        https://www.sir.advancedleadership.harvard.edu/Common Design Reusable Packaging: Doing More with Less — Harvard ALI Social Impact Review
                    </a>
           
              {/* Add remaining paragraphs following the same structure */}
            </div>
          </article>
        </main>

        {/* Right Column (Sidebar) */}
        <aside className="w-full lg:w-[410px] flex flex-col gap-[32px]">
          <h2 className="text-[32px] font-bold text-[#141414] leading-[38px]">More Articles</h2>
          
          <div className="flex flex-col gap-[32px]">
            {SIDEBAR_ARTICLES.map((article) => (
              <div key={article.id} className={`w-full bg-white border border-[#E4E7EC] rounded-[12px] overflow-hidden flex flex-col group ${article.heightClass}`}>
                <div className="w-full h-[289px] bg-slate-100 relative">
                  <img src={article.imageUrl} alt={article.title} className="w-full h-full object-cover" />
                </div>
                
                <div className="p-4 flex flex-col justify-between flex-grow">
                  <div className="flex flex-col gap-[11px]">
                    <div className="flex items-center gap-[8px]">
                      <span className={`text-[16px] font-medium uppercase ${article.typeColor}`}>{article.type}</span>
                      <span className="w-[6px] h-[6px] rounded-full bg-[#8D8484]" />
                      <div className="bg-[#3E3838] text-white text-[12px] px-[6px] py-[3px] rounded-[2px]">{article.tag}</div>
                    </div>
                    
                    <div className="flex flex-col gap-[8px]">
                      <h3 className="text-[20px] font-medium leading-[24px] line-clamp-2">{article.title}</h3>
                      <p className="text-[14px] text-[#898989] line-clamp-2">{article.excerpt}</p>
                    </div>
                  </div>

                  <div className="flex justify-between items-center border-t border-gray-100 pt-3 mt-4 text-[14px] text-[#3B3B3B]">
                    <span className="lowercase">{article.readTime}</span>
                    <span className="text-[12px] text-[#B1B1B1]">{article.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </aside>

      </div>
    </div>
  );
}